import { StatutsPaiement, TypesClient } from '@cockpit/shared';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
import { LABEL_STATUT_PAIEMENT, LABEL_TYPE_CLIENT } from '../../lib/format';

export interface VentesFiltersValue {
  period_from: string;
  period_to: string;
  user_id: string;
  statut_paiement: string;
  type_client: string;
}

interface Props {
  value: VentesFiltersValue;
  onChange: (v: VentesFiltersValue) => void;
  onReset: () => void;
}

export function VentesFilters({ value, onChange, onReset }: Props): JSX.Element {
  const set = (patch: Partial<VentesFiltersValue>): void => {
    onChange({ ...value, ...patch });
  };
  return (
    <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-3 items-end">
      <Input
        label="Période — du"
        type="date"
        value={value.period_from}
        onChange={(e): void => set({ period_from: e.target.value })}
      />
      <Input
        label="Au"
        type="date"
        value={value.period_to}
        onChange={(e): void => set({ period_to: e.target.value })}
      />
      <Select
        label="Commercial"
        value={value.user_id}
        onChange={(e): void => set({ user_id: e.target.value })}
        options={[
          { value: '1', label: 'Adam' },
          { value: '2', label: 'Mattéo' },
        ]}
        placeholder="Tous"
      />
      <Select
        label="Statut paiement"
        value={value.statut_paiement}
        onChange={(e): void => set({ statut_paiement: e.target.value })}
        options={StatutsPaiement.map((s) => ({ value: s, label: LABEL_STATUT_PAIEMENT[s] ?? s }))}
        placeholder="Tous"
      />
      <Select
        label="Type client"
        value={value.type_client}
        onChange={(e): void => set({ type_client: e.target.value })}
        options={TypesClient.map((t) => ({ value: t, label: LABEL_TYPE_CLIENT[t] ?? t }))}
        placeholder="Tous"
      />
      <button
        type="button"
        onClick={onReset}
        className="text-xs text-slate-400 hover:text-slate-200 underline self-end pb-2"
      >
        Réinitialiser
      </button>
    </div>
  );
}
